export const weatherLocation = [
  {
    id: 1,
    name: `Zakopane Krupówki`,
    location: {
      lat: 49.29378,
      lon: 19.95375,
    },
    image: `${process.env.PUBLIC_URL}/assets/img/krupowki.jpg`,
  },
  {
    id: 2,
    name: `Gubałówka`,
    location: {
      lat: 49.3075,
      lon: 19.935833,
    },
    image: `${process.env.PUBLIC_URL}/assets/img/Gubalowka.jpg`,
  },
  {
    id: 3,
    name: `Kuźnice`,
    location: {
      lat: 49.270336,
      lon: 19.981083,
    },
    image: `${process.env.PUBLIC_URL}/assets/img/Kuznice.jpg`,
  },
  {
    id: 4,
    name: `Myślenickie Turnie`,
    location: {
      lat: 49.251944,
      lon: 19.974167,
    },
    image: `${process.env.PUBLIC_URL}/assets/img/Myslenickie.jpg`,
  },
  {
    id: 5,
    name: `Kasprowy Wierch`,
    location: {
      lat: 49.231833,
      lon: 19.981556,
    },
    image: `${process.env.PUBLIC_URL}/assets/img/Kasprowy.jpg`,
  },
  {
    id: 6,
    name: `Polana Chochołowska`,
    location: {
      lat: 49.237222,
      lon: 19.793611,
    },
    image: `${process.env.PUBLIC_URL}/assets/img/Polana.jpg`,
  },
  {
    id: 7,
    name: `Morskie Oko`,
    location: {
      lat: 49.196944,
      lon: 20.07,
    },
    image: `${process.env.PUBLIC_URL}/assets/img/Morskie.jpg`,
  },
  {
    id: 8,
    name: `Dolina Pięciu Stawów Polskich`,
    location: {
      lat: 49.2097,
      lon: 20.0369,
    },
    image: `${process.env.PUBLIC_URL}/assets/img/Dolina.jpg`,
  },
  {
    id: 9,
    name: `Rysy`,
    location: {
      lat: 49.179306,
      lon: 20.088444,
    },
    image: `${process.env.PUBLIC_URL}/assets/img/Rysy.jpg`,
  },
];
